import { type NodeGraphDisplayMode, nodeGraphDisplayModeSchema } from '@tempo-io/roadmap-dto';
import type { Edge, Node } from '@xyflow/react';
import { z } from 'zod';

export type ItemNodeData = {
  itemKey: string | null;
  externalLink: string | null;
  title: string;
  itemTypeName: string;
  itemTypeId: number;
  itemTypeColor: string | null;
  status: string;
  statusColor: string | null;
};

export type ItemNode = Node<ItemNodeData, 'item'>;

export type EdgeKind = 'hierarchy' | 'dependency' | 'relationship';

export type ItemEdgeData = {
  kind: EdgeKind;
};

export type ItemEdge = Edge<ItemEdgeData>;

export type DisplayMode = NodeGraphDisplayMode;

export const nodeGraphSearchSchema = z.object({
  graphMode: nodeGraphDisplayModeSchema.catch('hierarchy').default('hierarchy'),
});

export type NodeGraphSearch = z.infer<typeof nodeGraphSearchSchema>;
